import { ICountryProvince } from 'src/app/core/interfaces/common/common/countryProvince.interface';
import { IStateProvince } from 'src/app/core/interfaces/common/common/stateProvince.interface';

export abstract class AbstractCommonService {
  abstract getStateProvince(): Promise<IStateProvince[]>;
  abstract getCountryProvince(): Promise<ICountryProvince[]>;
}
